import { SEARCH_COMPONENTS } from './search';
import { GRID_COMPONENTS } from './grids';
import { ASSORTED_COMPONENTS } from './assorted';
import { LAYOUT } from './layout';
import { IMAGE_COMPONENTS } from './images';
import { RateLimitIndicatorComponent } from './rate-limit-indicator.component';

export const COMPONENTS = [
  ...LAYOUT,
  ...SEARCH_COMPONENTS,
  ...GRID_COMPONENTS,
  ...ASSORTED_COMPONENTS,
  ...IMAGE_COMPONENTS,
  RateLimitIndicatorComponent
];

export {
  SEARCH_COMPONENTS,
  GRID_COMPONENTS,
  ASSORTED_COMPONENTS,
  IMAGE_COMPONENTS,
  RateLimitIndicatorComponent
};



// WEBPACK FOOTER //
// ./src/app/shared/components/index.ts